<template>
	<article class="dashboard_card" :class="{ is_refreshing: isLoading && hasData }">
		<header class="dashboard_card_header">
			<span class="dashboard_card_title">{{ title }}</span>
			<span v-if="subtitle" class="dashboard_card_subtitle">{{ subtitle }}</span>
		</header>
		<div class="dashboard_card_body">
			<p v-if="error" class="card_state card_state--error">{{ error }}</p>
			<!-- Primera carga: esqueleto con la forma del gráfico. Recarga (cambio
				de mes): el gráfico anterior queda atenuado hasta que llega el
				nuevo. -->
			<div v-else-if="isLoading && !hasData" class="card_skeleton" aria-hidden="true">
				<span v-for="n in 12" :key="n" class="skeleton_bar" :style="{ height: `${20 + ((n * 37) % 60)}%` }"></span>
			</div>
			<p v-else-if="!hasData" class="card_state">Sin datos en los últimos 12 meses.</p>
			<slot v-else />
		</div>
	</article>
</template>

<script>
// Card de los 4 gráficos del tab Dashboard: título, subtítulo, estados y el
// gráfico por slot. Mismas medidas que las cards del tab KPIs para que la
// grilla se lea como la misma familia.
export default {
	name: "DashboardChartCard",
	props: {
		title: { type: String, required: true },
		subtitle: { type: String, default: "" },
		isLoading: { type: Boolean, default: false },
		hasData: { type: Boolean, default: false },
		error: { type: String, default: "" },
	},
};
</script>

<style scoped lang="scss">
.dashboard_card {
	background: var(--report-bg);
	border: 1px solid var(--report-border);
	border-radius: 16px;
	box-shadow: var(--report-shadow-card);
	padding: 12px 12px 10px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	min-height: 0;
	transition: opacity 0.2s ease;

	&.is_refreshing .dashboard_card_body {
		opacity: 0.55;
		pointer-events: none;
	}
}

.dashboard_card_header {
	flex-shrink: 0;
	margin-bottom: 4px;
	display: flex;
	align-items: baseline;
	gap: 8px;
	min-width: 0;
}

.dashboard_card_title {
	color: var(--report-text);
	font-size: 14px;
	font-weight: 600;
	white-space: nowrap;
}

.dashboard_card_subtitle {
	color: var(--report-text-muted);
	font-size: 12px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.dashboard_card_body {
	flex: 1;
	min-height: 0;
	position: relative;
	display: flex;
	align-items: stretch;
	transition: opacity 0.2s ease;
}

.card_state {
	margin: auto;
	color: var(--report-text-muted);
	font-size: 13px;
	text-align: center;

	&--error { color: var(--report-negative); }
}

.card_skeleton {
	flex: 1;
	display: flex;
	align-items: flex-end;
	gap: 6px;
	padding: 24px 12px 12px;
}

.skeleton_bar {
	flex: 1;
	border-radius: 4px 4px 0 0;
	background: var(--report-divider-soft);
	animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.45; }
}

@media (prefers-reduced-motion: reduce) {
	.skeleton_bar { animation: none; }
	.dashboard_card, .dashboard_card_body { transition: none; }
}
</style>
